<div
  class="d-flex flex-column photo-selection-container"
  [attr.data-test-id]="'wrap-' + fieldAttribute.backendAttribute.name"
>
  <div class="d-flex">
    <img
      class="user-profile-avatar"
      [src]="photoLink || AppSettings.NO_PHOTO_DEFAULT_IMAGE"
      [attr.data-test-id]="'photo-box-' + fieldAttribute.backendAttribute.name"
      default="{{ AppSettings.NO_PHOTO_DEFAULT_IMAGE }}"
    />
    <app-file-form-field
      [inputContainerStyle]="'none-display'"
      [attribute]="fieldAttribute"
      [group]="form"
      [valid]="isFieldInvalid()"
      (fileUpdated)="updateFile($event)"
      (onError)="onError()"
    ></app-file-form-field>
    <div class="photo-btns-container">
      <button
        *ngIf="!(adminSession$ | async) && photoLink"
        class="btn btn-primary photo-btns"
        type="button"
        [attr.data-test-id]="'delete-photo-btn-' + fieldAttribute.backendAttribute.name"
        (click)="delete()"
      >
        {{ 'FIELD_DELETE_PHOTO_HINT' | translate }}
      </button>
      <button
        *ngIf="!(adminSession$ | async)"
        class="btn btn-primary photo-btns"
        type="button"
        [attr.data-test-id]="'add-change-photo-btn-' + fieldAttribute.backendAttribute.name"
        (click)="element.click()"
      >
        {{ (photoLink ? 'FIELD_CHANGE_PHOTO_HINT' : 'FIELD_ADD_PHOTO_HINT') | translate }}
      </button>
    </div>
  </div>
  <div class="d-flex">
    <small
      *ngIf="form.get(fieldAttribute.backendAttribute.name) && form.get(fieldAttribute.backendAttribute.name).invalid"
      class="d-flex mt-1 invalid-feedback"
      [attr.data-test-id]="fieldAttribute.errorDataTestId"
    >
      {{ getValidationError(form.get(fieldAttribute.backendAttribute.name)) | translate }}
    </small>
  </div>
</div>
